import { Link } from "@remix-run/react";
import { FiPhoneCall } from "react-icons/fi";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const ContactDetails = () => {
  const SALESCONTACT = "+61 1300664999";

  return (
    <div>
      <h2 className="mb-2 text-lg font-bold text-black dark:text-white">Contact Details</h2>
      <div className="space-y-1">
        <div className="flex items-start gap-2 mb-2">
          <FaMapMarkerAlt className="text-primary text-xl" aria-label="Location icon" />
          <div>
            <h2 className="text-xs font-semibold text-foreground mb-1">SHOWROOM AND OFFICE</h2>
            <p className="text-xs text-gray dark:text-gray-100 font-normal">
              Promotional Products Now
            </p>
            <p className="text-xs text-gray dark:text-gray-100 font-normal">
              Unit 9, 8 Avenue of the Americas
            </p>
            <p className="text-xs text-gray dark:text-gray-100 font-normal">NEWINGTON NSW 2127</p>
          </div>
        </div>

        <div className="flex items-start gap-2 mb-2">
          <FaMapMarkerAlt className="text-primary text-xl" aria-label="Location icon" />
          <div>
            <h2 className="text-xs font-semibold text-foreground mb-1">POSTAL ADDRESS</h2>

            <p className="text-xs text-gray dark:text-gray-100 font-normal">
              Promotional Products Now
            </p>
            <p className="text-xs text-gray dark:text-gray-100 font-normal">PO Box 6373 </p>
            <p className="text-xs text-gray dark:text-gray-100 font-normal">SILVERWATER NSW 2128</p>
          </div>
        </div>

        <div className="flex items-center gap-2 mb-3">
          <MdEmail className="text-primary text-2xl" aria-label="Email icon" />
          <Link
            to="mailto:sales@promotionalproductsnow.au"
            className="text-xs font-normal text-gray dark:text-gray-100 line-clamp-2"
            aria-label="Email sales at sales@promotionalproductsnow.au"
          >
            sales@promotionalproductsnow.au
          </Link>
        </div>
        <div className="flex items-center gap-4 mb-2">
          <FiPhoneCall className="text-primary text-lg" aria-label="Phone icon" />
          <Link
            to={`tel:+${SALESCONTACT}`}
            className="text-xs font-normal text-gray dark:text-gray-100"
            aria-label={`Call sales at ${SALESCONTACT}`}
          >
            +1300 664999
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
